module.exports = __webpack_public_path__ + "static/media/dks26.1adcd42d.png";